interface StarsProps {
  value: number;
  size?: string;
}

export default function Stars({ value, size = "text-base" }: StarsProps) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.25 && value - full < 0.75;
  const rounded = value - full >= 0.75 ? full + 1 : full;

  return (
    <span className="inline-flex items-center gap-0.5 text-accent-500">
      {[0, 1, 2, 3, 4].map((index) => {
        let icon = "ri-star-line";
        let tone = "text-accent-300";
        if (index < rounded) {
          icon = "ri-star-fill";
          tone = "text-accent-500";
        } else if (index === full && hasHalf) {
          icon = "ri-star-half-fill";
          tone = "text-accent-500";
        }
        return (
          <span
            key={index}
            className={`w-5 h-5 flex items-center justify-center ${tone} ${size}`}
          >
            <i className={icon}></i>
          </span>
        );
      })}
    </span>
  );
}